// extracted by mini-css-extract-plugin
export var footer = "_ne-0";
export var inherit = "_ne-1";
export var input = "_ne-2";
export var modalContent = "_ne-3";
export var quillEditor = "_ne-4";
export var subtitle = "_ne-5";